import type { FaireProductEntity } from "../../entity_types/product";

export const p_4w7a6pw4dz: FaireProductEntity = {
  token: "p_4w7a6pw4dz",
  type: "product",
  name: "Fashion Contrast Print Cardigan Casual Coat",
  brandToken: "b_n77n5vays8",
  brandName: "kycozy",
  imageUrl:
    "https://cdn.faire.com/fastly/b9c5620d94b329e401bc66a695859d49261fdfe4db737c26bffb4f1e08e93e54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c6be197ee889f24044580e12b312b7c8b37eddf49bfb823a4e2b9e62991c877.jpeg",
    "https://cdn.faire.com/fastly/7f24c4c3b71badb1ed0d741fa7b885f721940dbddfa1fba141230ae3b870ca9e.jpeg",
    "https://cdn.faire.com/fastly/8aa9dae944ea9763a184f2f114804c573320d12d9ab9102c4969f0060c08faaa.jpeg",
  ],
  priceDollars: 31.99,
  description:
    'Material:Dacron\n\nFeature:Zipper,Printing\n\nOccasion:Going out,Casual,Artistic Retro,Girlish Sweetness,Light Maturity,Leisure Fashion\n\nSeasons:Spring,Autumn,Winter\n\nSleeve Length:Long Sleeve\n\nType:Cardigan Coats\n\nStyle:Intellectual,All-match,Look-younger\n\nNeckline:Zipper Collar\n\nSleeve Style:Raglan Sleeve\n\nSize S (inch) : Bust= 46.02 ; Length= 22.62 ; \n\nSize M (inch) : Bust= 47.97 ; Length= 23.21 ; \n\nSize L (inch) : Bust= 49.92 ; Length= 23.79 ; \n\nSize XL (inch) : Bust= 51.87 ; Length= 24.38 ; \n\nSize 2XL (inch) : Bust= 53.82 ; Length= 24.96 ; \n\nAdorable cartoon print short sleeve top & shorts set - loose, cute & all-match Dacron homewear. Features square-neck design for intellectual retro style. Perfect for summer casual wear, leisure fashion & looking younger. Girlish sweetness meets light maturity in this artistic jumpsuit alternative. Great for going out or lounging!" (239 chars) \n\n#Cartoon short sleeve top and shorts set, \n\n#Dacron homewear set, \n\n#Loose cute short sleeve set, \n\n#Intellectual cartoon homewear, \n\n#All-match printing shorts set, \n\n#Look-younger square-neck top, \n\n#Casual artistic retro outfit, \n\n#Girlish sweetness summer wear, \n\n#Light maturity leisure fashion, \n\n#Sleeveless jumpsuits for summer,\n',
  tags: [],
  msrpDollars: 63.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:56.072Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
